import { Box } from "@chakra-ui/react";
import NoResults from "components/elements/NoResults";
import moment from "moment";
import { LoansContext } from "providers/loans";
import { useContext, useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import colors from "utils/colors";

const LoanProgress = () => {
  const { loans } = useContext(LoansContext);

  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const loansArray = loans as any[];
    const months: {
      [key: string]: any;
    } = {};

    loansArray.forEach((loan) => {
      if (moment(loan.funding_date).isValid()) {
        months[moment(loan.funding_date).format("MMM YY")] = 0;
      }
    });
    loansArray.forEach((loan) => {
      if (moment(loan.funding_date).isValid()) {
        const formattedFundingDate = moment(loan.funding_date).format("MMM YY");
        months[formattedFundingDate]++;
      }
    });
    const chartData: any[] = [];
    Object.keys(months).forEach((month) => {
      chartData.push({
        name: month,
        loans: months[month],
      });
    });

    setData(
      chartData.sort(
        (a, b) =>
          new Date(moment(a.name, "MMM YYY").toDate()).getTime() -
          new Date(moment(b.name, "MMM YYY").toDate()).getTime(),
      ),
    );
  }, [loans]);

  const barColors = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

  return data.length > 0 ? (
    <Box h="400px">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          barSize={16}
          margin={{
            top: 26,
            left: 0,
            bottom: 0,
            right: 0,
          }}
        >
          <CartesianGrid vertical={false} stroke="#F5F5F5" />
          <XAxis
            dataKey="name"
            type="category"
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
            tickCount={6}
            width={24}
            tick={{
              fontSize: "10px",
              color: colors.GRAY_300,
            }}
            domain={[
              0,
              data.reduce((prev, current) =>
                prev.loans > current.loans ? prev : current,
              ).loans + 1,
            ]}
          />
          <Bar
            dataKey="loans"
            fill={colors.PRIMARY}
            radius={[15, 15, 0, 0]}
            label={false}
          >
            <LabelList
              dataKey="loans"
              fontSize="16px"
              fontWeight="700"
              fill="#717579"
              position="top"
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  ) : (
    <NoResults message="Not enough data yet..." />
  );
};

export default LoanProgress;
